import { h, render, Component } from 'preact';
class AeScrollTop extends Component {
    constructor(props) {
        super(props);
        this.state = {
          showButton: false
        }
    }
    componentDidMount() {
      this.registerEvents();
    }
    registerEvents() {
      window.addEventListener("scroll", () => {
        if (window.pageYOffset > 300) {
          this.setShowButton(true);
        } else {
          this.setShowButton(false);
        }
      })
    }
    setShowButton(value) {
      this.setState( c => {
        c.showButton = value;
        return c;
      })
    }
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // for smoothly scrolling
      });
    };

    render() {
      return (
        <div className='back-to-top' onClick={this.scrollToTop.bind(this)} style={this.state.showButton ? {display: "block"} : {display: "none"}}>
          <div className='back-to-top-circle'></div>
        </div>
      )
    }
}
export default AeScrollTop;
